import { flow, reduce, toPairs } from 'lodash/fp';

const checkboxListToArray = (decodeName) => {
  const fn = flow(
    toPairs,
    reduce((acc, [key, val]) => {
      if (typeof val === 'object' && val !== null) {
        acc = { ...acc, [key]: fn(val) };
      } else if (val) {
        key = decodeName(key);

        acc = Array.isArray(acc) ? [...acc, key] : [key];
      }

      return acc;
    }, {}),
  );

  return fn;
};

export default checkboxListToArray;
